import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import { ReactComponent as TitleIcon } from "../../../../assests/images/settingsBreadCum.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useCallback, useEffect, useState } from "react";
import AccountCard from "../../../../components/account-card";
import AccountSelectedCard from "../../../../components/account-selected-card";
import { useSelector } from "react-redux";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../../../../store/selectors/app.selector";
import ChequeService from "../../../../services/cheque.service";
import AccountDisplay from "../../../../components/account-display";
import CommonOtp from "../../../../components/otp";
import { CONFIG } from "../../../../environment";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";
import {
  allowOnlyAlphaNumerics,
  amountFormat,
} from "../../../../services/common.service";
import moment from "moment";

export default function ChequeStatus() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [form] = Form.useForm();
  const selectedAccount = useSelector(selectedAccountSelector);
  const [formValues, setFormValues] = useState([]);
  const [chequeDetails, setChequeDetails] = useState({});
  const [otp, setOtp] = useState("");

  const chequeStatusVerify = useCallback(
    async (values) => {
      try {
        const reqParams = {
          brnCode: selectedAccount?.branchId,
          srcAccount: selectedAccount?.accountNo,
          chequeNo: values?.chequeNo,
        };
        setFormValues(reqParams);
        const response = await ChequeService.chequeStatusVerify(reqParams);
        if (response.status === 200) {
          if (response.data["data"]["otpEnable"]) {
            setStage(2);
          } else {
            chequeStatusConfirm({
              ...reqParams,
              ...{ otp: CONFIG.DEFAULT_OTP },
            });
          }
        }
      } catch (error) {}
    },
    [selectedAccount]
  );
  const chequeStatusConfirm = useCallback(async (values) => {
    try {
      const reqParams = {
        ...values,
      };
      const response = await ChequeService.chequeStatusConfirm(reqParams);
      if (response.status === 200) {
        setChequeDetails(response.data["data"]);
        setStage(3);
      }
    } catch (error) {}
  }, []);

  const handleResendOtp = useCallback(async (values) => {
    try {
      const response = await ChequeService.chequeStatusVerify(values);
      if (response.status === 200) {
      }
    } catch (error) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) =>
              chequeStatusConfirm({ ...values, ...formValues })
            }
            handleResendOtp={() => handleResendOtp(formValues)}
            cancelTransaction={() => {
              navigate("/request");
            }}
          />
        );
      case 3:
        return renderDetails();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <AccountDisplay type="image" />
            </div>
          </div>
        </div>
        <Form form={form} layout="vertical" onFinish={chequeStatusVerify}>
          <Form.Item
            label={t("pages.cheques.cheque_number", {
              defaultValue: "Cheque Number",
            })}
            name="chequeNo"
            rules={[{ required: true, message: "Cheque Number is required" }]}
          >
            <Input
              placeholder={t("pages.cheques.cheque_number", {
                defaultValue: "Cheque Number",
              })}
              size="large"
              onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
              maxLength={15}
            />
          </Form.Item>
          <div className="d-flex justify-content-end  mt-3">
            {" "}
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="primary-btn"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>{" "}
          </div>
        </Form>
      </>
    );
  }

  function renderDetails() {
    return (
      <>
        {" "}
        <p className="mb-3" style={{ fontSize: 17 }}>
          Cheque Details
        </p>
        <div className="confirm-details mt-2">
          <div className="row ">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span>{chequeDetails?.accountNo || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.cheques.cheque_number", {
                  defaultValue: "Cheque Number",
                })}
              </label>
              <span>{chequeDetails?.chequeNo || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.authorization.status", {
                  defaultValue: "Status",
                })}
              </label>
              <span>{chequeDetails?.status || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(chequeDetails?.amount) || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>Date On Cheque</label>
              <span>
                {moment(chequeDetails?.dateOnCheque).format("DD.MM.YYYY") ||
                  "-"}
              </span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bene_acc_no", {
                  defaultValue: "Beneficiary Account Number",
                })}
              </label>
              <span>{chequeDetails?.beneAccNo || "-"}</span>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end mt-4">
          <Button
            onClick={() => navigate("/request")}
            size="large"
            type="primary"
            className="primary-btn "
          >
            {" "}
            okay
          </Button>
        </div>
      </>
    );
  }

  return (
    <div>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/request")}>Request</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.cheques.cheque_status", {
                defaultValue: "Cheque Status",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            <TitleIcon height={30} style={{ marginLeft: "-20px" }} />
            <h3 className="title mb-0">
              {t("pages.cheques.cheque_status", {
                defaultValue: "Cheque Status",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className=" d-flex justify-content-between">
        <div className="row d-flex justify-content-between w-100 ">
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" >
              {stage === 1 ? <AccountCard /> : <AccountSelectedCard />}
            </Card>
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 ">
            <Card className="payee-render-section application-card">
              {renderSwitch()}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}